module.exports = __webpack_public_path__ + "assets/img/live.a22f9907.svg";